import styled from 'styled-components';

// ========================================
// Footer Components
// ========================================

export const Footer = styled.footer`
  margin-top: 4rem;
  padding: 1rem;
  text-align: center;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  margin-bottom: 1rem;

  @media (max-width: 1025px) {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }
  
  @media (max-width: 768px) {
    margin-left: 1.25rem;
    margin-right: 1.25rem;
  }
`;

export const FooterQuote = styled.p`
  font-style: italic;
  color: #555;
  font-size: 1rem;
  line-height: 1.6;
  margin: 0 0 0.5rem 0;
  margin-left: auto;
  margin-right: auto;
`;

export const FooterReference = styled.p`
  color: #234e9d;
  font-weight: bold;
  font-size: 0.9rem;
  margin: 0;
`;

// ========================================
// Categories Grid
// ========================================

export const CategoriesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 2rem;

  @media (max-width: 1025px) {
    margin-left: 1rem;
    margin-right: 1rem;
  }
  
  @media (max-width: 768px) {
    margin-left: 2.5rem;
    margin-right: 2.5rem;
  }

  @media (max-width: 480px) {
    margin-left: 1rem;
    margin-right: 1rem;
  }
`;

// ========================================
// Floating "Cómo Jugar" Button
// ========================================

export const FloatingButton = styled.button`
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  width: 160px;
  height: 160px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  z-index: 1000;
  transition: all 0.3s ease;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  
  &:hover {
    transform: scale(1.1) rotate(5deg);
    filter: drop-shadow(0 6px 12px rgba(0, 0, 0, 0.4));
  }
  
  &:active {
    transform: scale(1.05) rotate(3deg);
  }
  
  /* Subtle pulsing animation to draw attention */
  @keyframes pulse {
    0%, 100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.05);
    }
  }
  
  animation: pulse 2s ease-in-out infinite;
  
  &:hover {
    animation: none;
  }

  @media (max-width: 1024px) {
    width: 130px;
    height: 130px;
  }

  @media (max-width: 768px) {
    width: 100px;
    height: 105px;
    bottom: 1rem;
    right: 1rem;
  }

  @media (max-width: 480px) {
    width: 90px;
    height: 95px;
    bottom: 0.5rem;
    right: 0rem;
  }
`;

// ========================================
// Modal Components
// ========================================

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 1rem;
  animation: fadeIn 0.3s ease;
  
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const ModalContent = styled.div`
  position: relative;
  width: 100%;
  max-width: 1200px;
  height: 90vh;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  animation: slideUp 0.3s ease;
  
  @keyframes slideUp {
    from {
      transform: translateY(50px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @media (max-width: 768px) {
    height: 85vh;
    max-width: 95%;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 2px solid #e0e0e0;
  background: linear-gradient(135deg, rgba(252, 213, 23, 1) 0%, rgba(35, 78, 157, 1) 100%);
  border-radius: 12px 12px 0 0;
  
  h2 {
    margin: 0;
    color: white;
    font-size: 1.5rem;
    font-weight: bold;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  }

  @media (max-width: 768px) {
    padding: 1rem;
    
    h2 {
      font-size: 1.2rem;
    }
  }
`;

export const CloseButton = styled.button`
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid white;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: white;
  transition: all 0.2s ease;
  padding: 0;
  
  svg {
    width: 22px;
    height: 22px;
  }
  
  &:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: rotate(90deg) scale(1.1);
  }
  
  &:active {
    transform: rotate(90deg) scale(0.95);
  }
`;

export const PDFContainer = styled.div`
  flex: 1;
  overflow: hidden;
  border-radius: 0 0 12px 12px;
  
  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
`;

// ========================================
// Mobile PDF Viewer Components
// ========================================

export const MobileMessageContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
  gap: 1.5rem;

  @media (max-width: 480px) {
    padding: 1.5rem;
    gap: 1rem;
  }
`;

export const MobileIcon = styled.div`
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, rgba(252, 213, 23, 0.2) 0%, rgba(35, 78, 157, 0.2) 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    width: 40px;
    height: 40px;
    color: #234e9d;
  }

  @media (max-width: 480px) {
    width: 60px;
    height: 60px;
    
    svg {
      width: 30px;
      height: 30px;
    }
  }
`;

export const MobileTitle = styled.h3`
  margin: 0;
  color: #234e9d;
  font-size: 1.5rem;
  font-weight: bold;

  @media (max-width: 480px) {
    font-size: 1.2rem;
  }
`;

export const MobileDescription = styled.p`
  margin: 0;
  color: #555;
  font-size: 1rem;
  line-height: 1.6;
  max-width: 500px;

  @media (max-width: 480px) {
    font-size: 0.9rem;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
  flex-wrap: wrap;
  justify-content: center;

  @media (max-width: 480px) {
    flex-direction: column;
    width: 100%;
    gap: 0.75rem;
  }
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  
  ${props => props.primary ? `
    background: linear-gradient(135deg, rgba(252, 213, 23, 1) 0%, rgba(35, 78, 157, 1) 100%);
    color: white;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
    }
  ` : `
    background: white;
    color: #234e9d;
    border: 2px solid #234e9d;
    
    &:hover {
      background: #f0f4ff;
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(35, 78, 157, 0.2);
    }
  `}
  
  &:active {
    transform: translateY(0);
  }
  
  svg {
    width: 20px;
    height: 20px;
  }

  @media (max-width: 480px) {
    width: 100%;
    justify-content: center;
    padding: 1rem 1.5rem;
  }
`;

